import { createSelector } from '@reduxjs/toolkit';

import { ComponentMaterialStockLengths, getLoggedInUsersOrganizationMaterialSet } from '@paragon/material-lists';

import { RootState } from '../index';

export const getComponentInventoryStockLengths = createSelector(
  (state: RootState) => state.componentDesigns.data,
  getLoggedInUsersOrganizationMaterialSet,
  (componentDesigns, materialSet) =>
    materialSet ? new ComponentMaterialStockLengths(Object.values(componentDesigns), materialSet) : null,
);
